import React from 'react';
import './Style/AccountDeletion.css'; 
import TopNavbar from '../home/TopNavbar';

const AccountDeletionInstructions = () => {
  const contactEmail = "contact@mystudyplace.in";

  return (
    <div className="account-delete-container">
      <div className="account-delete-card">
        <h1>Account Deletion Guide</h1>
        <p className="account-delete-timestamp">Last Updated: July 2026</p>

        <TopNavbar name="Delete Account" />


        <section>
          <h2>Data Deletion Policy</h2>
          <p>
            At <strong>NEET Prep</strong>, we respect your privacy and give you full control over your personal data. You can request the complete erasure of your account information at any time. 
          </p>
          <p>
            Please note that executing an account deletion is <strong>permanent</strong>. All your saved profile identifiers, credentials, and mock test performance history will be wiped from our secure backend databases immediately.
          </p>
        </section>

        {/* Highlighted Instruction Section */}
        <section className="account-delete-steps-box">
          <h2>How to Delete Your Account In-App</h2>
          <p>You can delete your account and all associated data directly inside our mobile application  by following these steps:</p>
          <ul>
            <li><strong>Step 1:</strong> Open the <strong>NEET Prep</strong> app and  ensure you are logged into your profile.</li>
            <li><strong>Step 2:</strong> Navigate to your <strong>Profile Menu</strong> or <strong>Settings</strong> dashboard.</li>
            <li><strong>Step 3:</strong> Tap on the <strong>"Delete Account"</strong> option located at the bottom of profile page.</li>
            <li><strong>Step 4:</strong> Confirm your choice on the security prompt. Your data will be deleted instantly.</li>
          </ul>
        </section>

        <section>
          <h2>Alternative Deletion Requests</h2>
          <p>
            If you are unable to access the mobile application or prefer to submit a manual erasure request, you can contact our technical support administration. 
          </p>
          <p>
            Please email us from your registered account address, and our team will process your database removal within 24 to 48 hours:
          </p>
          <p>
            Email: <a href={`mailto:${contactEmail}`} className="account-delete-email-btn">{contactEmail}</a>
          </p> 
        </section>
      </div>
    </div>
  );
};

export default AccountDeletionInstructions;